import * as React from 'react'
import { StyledTooltip, StyledTooltipContainer, StyledTooltipTitle } from './styled'
import { TooltipProps } from './types'
import styled from 'styled-components'

const StyledText = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.1;
`
export const Tooltip = ({ children, component, title, text, noWrap = false }: TooltipProps) => {
  return (
    <StyledTooltipContainer>
      {(title || text || component) && (
        <StyledTooltip $noWrap={noWrap}>
          {
            <>
              {title && <StyledTooltipTitle>{title}</StyledTooltipTitle>}
              {text ? <StyledText>{text}</StyledText> : component}
            </>
          }
        </StyledTooltip>
      )}
      {children}
    </StyledTooltipContainer>
  )
}
